import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Clock,
  Mail,
  User,
  Settings,
  Users,
  Edit,
} from 'lucide-react';

interface NavItemProps {
  to: string;
  icon: React.ElementType;
  label: string;
  isCollapsed: boolean;
  isMobileMenuOpen: boolean;
  onClick?: () => void;
}

const NavItem = ({ to, icon: Icon, label, isCollapsed, isMobileMenuOpen, onClick }: NavItemProps) => (
  <NavLink
    to={to}
    end={to === '/admin'}
    onClick={onClick}
    className={({ isActive }) =>
      `flex items-center w-full ${isMobileMenuOpen ? '' : isCollapsed ? 'justify-center' : ''} px-4 py-2.5 rounded-xl transition-colors ${
        isActive
          ? 'bg-blue-50 text-blue-600'
          : 'text-gray-600 hover:bg-gray-50'
      }`
    }
    title={label}
  >
    <Icon className="h-5 w-5 flex-shrink-0" style={{ marginRight: isMobileMenuOpen ? '0.75rem' : isCollapsed ? '0' : '0.75rem' }} />
    {(!isCollapsed || isMobileMenuOpen) && label}
  </NavLink>
);

interface SidebarNavigationProps {
  isAdmin: boolean;
  isPremium: boolean;
  isCollapsed: boolean;
  isMobileMenuOpen: boolean;
  onNavItemClick?: () => void;
}

export function SidebarNavigation({ 
  isAdmin, 
  isPremium,
  isCollapsed, 
  isMobileMenuOpen, 
  onNavItemClick 
}: SidebarNavigationProps) {
  const navItems = [
    {
      to: '/admin',
      icon: LayoutDashboard,
      label: 'Painel',
    },
    {
      to: '/admin/escrever-carta',
      icon: Edit,
      label: 'Escrever Carta',
    },
    {
      to: '/admin/cartas-agendadas',
      icon: Clock,
      label: 'Cartas Agendadas',
    },
    {
      to: '/admin/cartas-disponiveis', 
      icon: Mail,
      label: 'Cartas Disponíveis',
    },
    {
      to: '/admin/conta', 
      icon: User,
      label: 'Minha Conta',
    },
    {
      to: '/admin/configuracoes',
      icon: Settings,
      label: 'Configurações',
    }
  ];
  
  // Adicionar o item de gerenciamento de usuários apenas para admins
  const adminItems = isAdmin ? [
    {
      to: '/admin/usuarios',
      icon: Users,
      label: 'Gerenciar Usuários',
    }
  ] : [];

  const allNavItems = [...navItems, ...adminItems];

  return (
    <nav className="flex-1 p-4 space-y-1">
      {allNavItems.map((item) => (
        <NavItem
          key={item.to}
          to={item.to}
          icon={item.icon}
          label={item.label}
          isCollapsed={isCollapsed}
          isMobileMenuOpen={isMobileMenuOpen}
          onClick={onNavItemClick}
        />
      ))}
    </nav>
  );
}